import { Flex, Image, Button, Text } from "@chakra-ui/react";

import { AiOutlineCloseCircle } from "react-icons/ai";

export const VisualizarFoto = ({ foto, onClose, visualizarFoto }) => {
  return (
    <Flex
      position="fixed"
      w="100%"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      zIndex="999"
      bg="rgba(0,0,0,0.5)"
      h="100vh"
    >
      <Flex align="center" justify="center" flexDir="column" w="full">
        <div
          style={{
            position: "relative",
          }}
        >
          <Image src={foto} />
          {!!foto && (
            <Button
              position="absolute"
              top="0"
              right="0"
              onClick={() => onClose(!visualizarFoto)}
              bg="transparent"
              _hover={{ bg: "transparent" }}
            >
              <Flex align="center" gap={2}>
                <Text fontSize="1rem" color="white">
                  Fechar
                </Text>

                <AiOutlineCloseCircle size={20} color="white" />
              </Flex>
            </Button>
          )}
        </div>
      </Flex>
    </Flex>
  );
};
